export const MICA_CONNECT_PLATFORM_META = "meta";
export const MICA_CONNECT_PURPOSE = "mica_connect";

export { MICA_CONNECT_SUCCESS_MESSAGE } from "../../../utils/micaRedirectUrls";

/** @deprecated Use MICA_CONNECT_SUCCESS_MESSAGE via redirect-mica flow */
export { MICA_CONNECT_SUCCESS_MESSAGE as MICA_SIMULATOR_SUCCESS_MESSAGE } from "../../../utils/micaRedirectUrls";

/**
 * Extensible registry of MICA connect drivers.
 * Add future platforms by registering a driver — do not hardcode flows in the page.
 */
const drivers = {};

export const registerMicaConnectDriver = (platform, driver) => {
  if (
    !platform ||
    !driver?.id ||
    typeof driver.validate !== "function" ||
    typeof driver.connect !== "function"
  ) {
    throw new Error("Invalid MICA connect driver");
  }
  drivers[platform] = driver;
};

export const getMicaConnectDriver = (platform) => {
  const key = String(platform || "")
    .trim()
    .toLowerCase();
  // Instagram is a capability obtained via Meta; resolve to Meta driver.
  if (key === "instagram") {
    return drivers[MICA_CONNECT_PLATFORM_META] || null;
  }
  return drivers[key] || null;
};

export const listMicaConnectDrivers = () => Object.values(drivers);

export const resolveMicaConnectPlatform = (platform) => {
  const key = String(platform || "")
    .trim()
    .toLowerCase();
  if (key === "instagram") return MICA_CONNECT_PLATFORM_META;
  return key;
};
